import { computed, inject, Injectable, Signal } from '@angular/core';
import { NavigationRepositoryService } from './navigation-repository.service';
import { AppIdentity, IDENTITY_SIGNAL } from '../auth/identity.token';
import { NavItem } from '@shared/ui/nav-menu/nav-menu.model';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private user: Signal<AppIdentity | null> = inject(IDENTITY_SIGNAL);

  private repo = inject(NavigationRepositoryService);
  readonly menuItems = computed<NavItem[]>(() => {
    const currentUser = this.user();
    console.log('current user is: ', currentUser);
    if (currentUser) {
      return this.initMenuItems(currentUser.roles);
    }

    return [];
  });

  initMenuItems(roles: string[]): NavItem[] {
    const menuItems = this.repo.initMenuItems();
    const userItems = menuItems.filter((item) => {
      for (const group of item.groups) {
        if (roles.includes(group)) {
          if (item.children) {
            const filteredChildren = item.children.filter((citem) => {
              for (const cgroup of citem.groups) {
                if (roles.includes(cgroup)) return true;
              }
              return false;
            });

            item.children = filteredChildren;
          }

          return true;
        }
      }
      return false;
    });

    return userItems;
  }
}
